import { createResource, createSignal, Show } from "solid-js";
import { api } from "../../store/api";

// Renders the LlamaParse markdown for one source, one page at a time. Raw
// markdown is shown as preformatted text: no client-side markdown engine is
// pulled in for this read-only viewer.
export function ParsedPageViewer(props: {
  clientId: string;
  sourceId: string;
}) {
  const [pages] = createResource(
    () => [props.clientId, props.sourceId] as const,
    ([clientId, sourceId]) => api.tov.parsedPages(clientId, sourceId),
  );
  const [index, setIndex] = createSignal(0);

  const list = () => pages()?.pages ?? [];
  const current = () => list()[Math.min(index(), list().length - 1)];
  const move = (delta: number) =>
    setIndex((value) =>
      Math.max(0, Math.min(list().length - 1, value + delta)),
    );

  return (
    <div class="tov-parsed-viewer">
      <Show
        when={current()}
        fallback={<p class="tov-sub">No parsed pages yet.</p>}
      >
        {(page) => (
          <>
            <div class="tov-parsed-nav">
              <button
                type="button"
                class="tov-tab"
                disabled={index() === 0}
                onClick={() => move(-1)}
              >
                Prev
              </button>
              <span class="tov-chip muted">
                page {page().pageNumber} ({index() + 1}/{list().length})
              </span>
              <button
                type="button"
                class="tov-tab"
                disabled={index() >= list().length - 1}
                onClick={() => move(1)}
              >
                Next
              </button>
            </div>
            <pre class="tov-parsed-markdown">{page().markdown}</pre>
          </>
        )}
      </Show>
    </div>
  );
}
